import React, { useState, useEffect } from 'react';
import CheckboxInput from 'src/Member/components/common/checkbox';
import GenericButton from '../../../../../Components/GenericButton/GenericButton';
import {
  ProductVisionIcon,
  EnrollPlusIcon,
  EnrollMinusIcon,
} from '../EnrollmentIconsSvg';
import './styles/product-selection.scss';

const ProductVisionRow = ({
  data,
  selectedCheckedItems,
  setSelectedCheckedItems,
  selectedCheckedRowData,
  setSelectedCheckedRowData,
  enrollmentFormData,
  setEnrollmentFormData,
  onSelectedProducts,
  onSelectedEnrollMembers,
  selectedTab,
  isTabClicked,
  setIsTabClicked,
  isNotReviewPage = true,
}) => {
  const [checked, setChecked] = useState(false);
  const [selectPlan, setSelectPlan] = useState(false);
  const [enrollmentLists, setEnrollmentLists] = useState(false);
  const [enrollMember, setEnrollMember] = useState(false);

  const [arrVisionMember, setArrVisionMember] = useState([]);

  const onSelectRowHandler = (e, data, planId) => {
    //setIsTabClicked(false);
    setChecked(e.target.checked);
    if (e.target.checked) {
      setSelectedCheckedItems([...selectedCheckedItems, planId]);
      setSelectedCheckedRowData([...selectedCheckedRowData, data]);
    } else {
      setSelectedCheckedItems(
        selectedCheckedItems.filter((id) => id !== planId),
      );
      setSelectedCheckedRowData(
        selectedCheckedRowData.filter((item) => item.planId !== planId),
      );
    }
  };

  const selectPlanForMemberDependents = (data) => {
    console.log('selectPlanForMemberDependents', data);
    /*if (
      selectedTab === 'medical' &&
      document.getElementsByClassName('remove-selected-plan-button')[0] !==
        undefined
    ) {
      document.getElementsByClassName('remove-selected-plan-button')[0].click();
    }*/
    /*if (
      selectedTab === 'dental' &&
      document.getElementsByClassName(
        'remove-selected-plan-button-dental',
      )[0] !== undefined
    ) {
      document
        .getElementsByClassName('remove-selected-plan-button-dental')[0]
        .click();
    }*/
    /*------*/
    if (
      selectedTab === 'vision' &&
      document.getElementsByClassName(
        'remove-selected-plan-button-vision',
      )[0] !== undefined
    ) {
      document
        .getElementsByClassName('remove-selected-plan-button-vision')[0]
        .click();
    }
    setSelectPlan(true);
    const newDependents = enrollmentFormData.allNewlyAddedDependent;
    setEnrollmentLists(newDependents);
    onSelectedProducts(data);
  };

  const removePlanForMemberDependents = () => {
    setSelectPlan(false);
    setEnrollmentLists([]);
    setArrVisionMember([]);
    onSelectedProducts(null);
    onSelectedEnrollMembers(null);
  };

  const addMember = (member_name) => {
    console.log('addMember', member_name);
    setArrVisionMember([...arrVisionMember, member_name]);
    setEnrollMember(true);
    onSelectedEnrollMembers([...arrVisionMember, member_name]);
  };

  const removeMember = (member_depSequenceNumber) => {
    setArrVisionMember(
      arrVisionMember.filter(
        (m) => m.DepSequenceNumber !== member_depSequenceNumber,
      ),
    );
    setEnrollMember(false);
    onSelectedEnrollMembers(
      arrVisionMember.filter(
        (m) => m.DepSequenceNumber !== member_depSequenceNumber,
      ),
    );
  };

  const showNetworks = (arr) => {
    const arrA = arr.length > 3 ? arr.slice(0, 3) : arr;
    return arrA.join(',');
  };

  console.log('arrVisionMember', arrVisionMember);
  console.log('product row enrollmentFormData', enrollmentFormData);
  console.log('isTabClicked', isTabClicked);

  useEffect(() => {
    if (isTabClicked) {
      setChecked(false);
    }
    setTimeout(() => {
      setIsTabClicked(false);
    }, 1000);
  }, [isTabClicked]);

  useEffect(() => {
    if (
      enrollmentFormData &&
      enrollmentFormData.products &&
      enrollmentFormData.products.selectedVisionProduct !== null &&
      enrollmentFormData.products.selectedVisionProduct.planId === data.planId
    ) {
      /*const selectBtnId = `btn-${enrollmentFormData.products.selectedVisionProduct.planId}`;
      console.log('HERE===>', document.getElementById(selectBtnId));
      if (document.getElementById(selectBtnId) !== null) {
        document.getElementById(selectBtnId).click();
      }*/
      selectPlanForMemberDependents(
        enrollmentFormData.products.selectedVisionProduct,
      );
    }
  }, [
    enrollmentFormData,
    enrollmentFormData.products,
    enrollmentFormData.products.selectedVisionProduct,
    data,
  ]);

  useEffect(() => {
    if (
      enrollmentFormData &&
      enrollmentFormData.products &&
      enrollmentFormData.products.selectedVisionProduct !== null &&
      enrollmentFormData.products.enrolledVisionMember !== null &&
      enrollmentFormData.products.enrolledVisionMember.length > 0 &&
      enrollmentFormData.products.selectedVisionProduct.planId === data.planId
    ) {
      const arr = [];
      for (const enrolledVisionMember of enrollmentFormData.products
        .enrolledVisionMember) {
        arr.push(enrolledVisionMember);
      }
      setArrVisionMember(arr);
      setEnrollMember(true);
      onSelectedEnrollMembers(arr);
    } else {
      const newDependents = enrollmentFormData.allNewlyAddedDependent;
      setEnrollmentLists(newDependents);
    }
  }, [
    enrollmentFormData,
    enrollmentFormData.products,
    enrollmentFormData.products.selectedVisionProduct,
    enrollmentFormData.products.enrolledVisionMember,
    data,
  ]);

  return (
    <div className="product-row">
      <div className="p-row">
        <div className="left-col">
          <div className="product-column">
            <div className="prouduct-top-row">
              {isNotReviewPage && (
                <div className="col-checkbox">
                  <div>
                    <CheckboxInput
                      inline
                      key={data.planId}
                      label=""
                      name={data.planId}
                      value={data.planId}
                      className="cursor-pointer"
                      id={data.planId}
                      onChange={(e) => {
                        onSelectRowHandler(e, data, data.planId);
                      }}
                      checked={
                        checked && selectedCheckedItems.includes(data.planId)
                      }
                      isDisabled={
                        selectedCheckedItems.length >= 3 &&
                        !selectedCheckedItems.includes(data.planId)
                      }
                      /*isDisabled={
                    selectedCheckedItems.length >= 3 &&
                    !checked &&
                    !selectedCheckedItems.includes(data.ConnectorId)
                  }*/
                      ariaDisabled={
                        (data?.currentPlan && !checked) ||
                        (selectedCheckedItems.length >= 3 &&
                          !checked &&
                          !selectedCheckedItems.includes(data.planId))
                      }
                      ariaLabel={
                        (data?.currentPlan && !checked) ||
                        (selectedCheckedItems.length >= 3 &&
                          !checked &&
                          !selectedCheckedItems.includes(data.planId))
                          ? 'you have selected maximum 3 products to compare'
                          : 'select the products to compare'
                      }
                    />
                  </div>
                  <div>Compare</div>
                </div>
              )}
              <div className="col-icon">
                <ProductVisionIcon
                  classNameSecondary="vision-product-icon-secondary"
                  classNamePrimary="vision-product-icon"
                />
              </div>
              <div className="col-product-name">
                <div className="product-title">{data?.planTitle}</div>
                <div className="product-desc">{data?.planDesc}</div>
              </div>
            </div>
            <div className="prouduct-bottom-row">
              <div className="bottom-1">
                <div className="bottom-title">Networks</div>
                <div className="bottom-desc">
                  {showNetworks(data?.networks)}{' '}
                  {data?.networks.length > 3 && (
                    <span className="bottom-more">
                      +{data?.networks.slice(3, data?.networks.length).length}{' '}
                      Networks
                    </span>
                  )}
                </div>
              </div>
              <div className="bottom-2">
                <div className="bottom-bold-title">In-Network</div>
                <div className="amount-container">
                  <div>
                    <div className="bottom-title">Deductible</div>
                    <div className="bottom-bold-title">
                      {data?.inNetworkDeductible}
                    </div>
                  </div>
                  <div>
                    <div className="bottom-title">Out-of-pocket</div>
                    <div className="bottom-bold-title">
                      {data?.inNetworkOutOfPocket}
                    </div>
                  </div>
                </div>
              </div>
              <div className="bottom-3">
                <div className="bottom-bold-title">Out-of-network</div>
                <div className="amount-container">
                  <div>
                    <div className="bottom-title">Deductible</div>
                    <div className="bottom-bold-title">
                      {data?.outOfNetworkDeductible}
                    </div>
                  </div>
                  <div>
                    <div className="bottom-title">Out-of-pocket</div>
                    <div className="bottom-bold-title">
                      {data?.outOfNetworkOutOfPocket}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="right-col">
          <div className="plan-column">
            <div className="plan-column-1">
              {data?.currentPlan && (
                <div className="plan-current">Current Plan</div>
              )}
              <div className="plan-price">{data?.monthlyPremium}</div>
              <div className="plan-premium">Monthly Premium</div>
              {data?.monthlyAmount !== '' && (
                <div className="plan-amount">
                  ({data?.monthlyAmount} Monthly)
                </div>
              )}
              {data?.monthlyAmount === '' && data?.currentPlan && (
                <div className="plan-amount">(No Change)</div>
              )}
            </div>
            <div className="plan-column-2">
              <>
                {!selectPlan && (
                  <div className="button-div">
                    <GenericButton
                      type="button"
                      className="mr-0"
                      //id={`btn-${data?.planId}`}
                      onClick={() => {
                        selectPlanForMemberDependents(data);
                      }}
                    >
                      SELECT
                    </GenericButton>
                  </div>
                )}
                {selectPlan && (
                  <div>
                    <span className="selected-plan-button">SELECTED</span>{' '}
                    {/*selectedTab === 'medical' && (
                      <span
                        className="remove-selected-plan-button"
                        onClick={() => {
                          removePlanForMemberDependents();
                        }}
                      >
                        X
                      </span>
                      )*/}
                    {/*selectedTab === 'dental' && (
                      <span
                        className="remove-selected-plan-button-dental"
                        onClick={() => {
                          removePlanForMemberDependents();
                        }}
                      >
                        X
                      </span>
                      )*/}
                    {selectedTab === 'vision' && (
                      <span
                        className="remove-selected-plan-button-vision"
                        onClick={() => {
                          removePlanForMemberDependents();
                        }}
                      >
                        X
                      </span>
                    )}
                  </div>
                )}
              </>
              <div className="plan-details">View Details</div>
            </div>
          </div>
        </div>
      </div>
      {selectPlan && (
        <div className="dependents-row">
          <div>
            <span className="enroll-name-title-1">
              <b>Enroll Dependents</b>
            </span>{' '}
            <span className="enroll-name-title-2">
              ({arrVisionMember && arrVisionMember.length} New Dependent(s))
            </span>
          </div>
          <div>
            {enrollmentLists &&
              enrollmentLists.map((member) => (
                <>
                  {console.log(
                    'includes(e)',
                    arrVisionMember,
                    arrVisionMember.includes(member),
                  )}
                  <div
                    className={
                      !enrollMember
                        ? !arrVisionMember.includes(member)
                          ? 'enroll-plus-block'
                          : 'enroll-minus-block'
                        : arrVisionMember.includes(member)
                        ? 'enroll-minus-block'
                        : 'enroll-plus-block'
                    }
                    key={member}
                  >
                    {member.DepFirstName}{' '}
                    {isNotReviewPage &&
                      (!enrollMember ? (
                        !arrVisionMember.includes(member) ? (
                          <span onClick={() => addMember(member)}>
                            <EnrollPlusIcon className="enroll-plus-icon" />
                          </span>
                        ) : (
                          <span
                            onClick={() =>
                              removeMember(member.DepSequenceNumber)
                            }
                          >
                            <EnrollMinusIcon className="enroll-minus-icon" />
                          </span>
                        )
                      ) : arrVisionMember.includes(member) ? (
                        <span
                          onClick={() => removeMember(member.DepSequenceNumber)}
                        >
                          <EnrollMinusIcon className="enroll-minus-icon" />
                        </span>
                      ) : (
                        <span onClick={() => addMember(member)}>
                          <EnrollPlusIcon className="enroll-plus-icon" />
                        </span>
                      ))}
                  </div>
                </>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductVisionRow;
